import { api } from './client';
import type { LoginRequest, LoginResponse, TelegramLoginRequest, UserCreate, UserRead, UserUpdate, AccessToken } from './types';
import { accountDeletionResult, accountDeletionResultFromError } from './account-deletion';

export const authApi = {
  login: (body: LoginRequest) => api.post<LoginResponse>('/api/v1/auth/login', body).then(r => r.data),
  telegramLogin: (body: TelegramLoginRequest) => api.post<LoginResponse>('/api/v1/auth/telegram', body).then(r => r.data),
  register: (body: UserCreate) => api.post<UserRead>('/api/v1/auth/register', body).then(r => r.data),
  refresh: () => api.post<AccessToken>('/api/v1/auth/refresh').then(r => r.data),
  logout: () => api.post('/api/v1/auth/logout'),
  me: () => api.get<UserRead>('/api/v1/users/me').then(r => r.data),
  updateMe: (body: UserUpdate) => api.put<UserRead>('/api/v1/users/me', body).then(r => r.data),
  updateAiConsent: (enabled: boolean) => api.put<{ enabled: boolean }>(
    '/api/v1/users/me/consents/ai',
    { enabled },
  ).then(r => r.data),
  updateLegalConsents: () => api.put<{ accepted: boolean; legal_version: string }>(
    '/api/v1/users/me/consents/legal',
    { accept_terms: true, accept_personal_data: true },
  ).then(r => r.data),
  deleteMe: async (password?: string) => {
    try {
      const response = await api.post('/api/v1/users/me/delete', {
        confirmation: 'DELETE',
        password,
      });
      return accountDeletionResult(response.status, response.data);
    } catch (error) {
      const result = accountDeletionResultFromError(error);
      if (result) return result;
      throw error;
    }
  },
};
